import { ConfiguratorUIElementStates, ConfiguratorUIElementWithChildrenState } from '@/stores/CfgUIElementState';

import React from 'react';

import { IUiCfgContainer } from '@canvas-logic/clp-api-types';

let id = 0;

export class AttributesContainerCfgUIElementState extends ConfiguratorUIElementWithChildrenState {
  constructor(children: Array<ConfiguratorUIElementStates>, viewElement: IUiCfgContainer) {
    super(children, viewElement);
  }

  render(): React.ReactElement {
    return (
      <div className={'cp-attribute-container'} key={this.viewElement.id}>
        {this.children.map((child) => child.render())}
      </div>
    );
  }
}
